"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _reactRedux = require("react-redux");
var _axios = _interopRequireDefault(require("axios"));
var _components = require("../components");
var _auth = require("../modules/auth");
var _base = require("../modules/base");
var _ = require("../");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
window.axios = _axios.default;
const registerReducer = (store, name, reducer) => {
  store.async[name] = reducer;
  store.replaceReducer(createReducer(store.async));
};
const createReducer = reducers => {
  return (0, _redux.combineReducers)({
    base: _base.reducer,
    auth: _auth.reducer,
    ...reducers
  });
};
const composeEnhancers = process.env.REACT_APP_STAGE !== "production" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
const store = (() => {
  const store = (0, _redux.createStore)(createReducer(), composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default)));
  store.async = {};
  return store;
})();
const m = store => {
  const modules = {};
  return (name, moduleProvider) => {
    if (Object.prototype.hasOwnProperty.call(modules, name)) {
      // return Promise.resolve(modules[name]);
    } else {
      // const mod = modules[name];
      registerReducer(store, name, moduleProvider);
      return modules[name];
    }
  };
};
const addReducer = m(store);
class ControlPanel extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "register", modules => {
      if (!modules) return;
      this.modulesLength = modules.length;
      modules.map(module => {
        if (module.module) {
          this.initModule(module, module.module);
        } else {
          (specifier => new Promise(r => r(specifier)).then(s => _interopRequireWildcard(require(s))))(`../modules/${module.name}`).then(lazyModule => {
            this.initModule(module, lazyModule);
          });
        }
        return module;
      });
    });
    _defineProperty(this, "initModule", (module, lazyModule) => {
      addReducer(module.name, lazyModule.reducer);

      // extract routes

      Object.entries(lazyModule.routes).map(([name, route]) => {
        if (route.component) this.routes.push({
          ...route,
          path: `/${route.path}`
        });
      });

      // generate links ready for vertical menu

      Object.entries(lazyModule.routes).map(([name, route]) => {
        if (typeof route.level === "undefined") return;
        if (!this.links[module.name]) {
          this.links[module.name] = {
            links: []
          };
        }
        if (route.level === 0) {
          this.links[module.name] = {
            path: `/${route.path}`,
            title: route.title,
            icon: route.icon,
            private: route.private,
            restricted: route.restricted
          };
        }
        if (route.level === 1) {
          if (!this.links[module.name].links) this.links[module.name].links = [];
          this.links[module.name].links.push({
            path: `/${route.path}`,
            title: route.title,
            icon: route.icon,
            private: route.private,
            restricted: route.restricted
          });
        }
      });
      this.links = Object.entries(this.links).map(([key, value]) => value);

      // merge custom schema into module schema

      const schema = lazyModule.schema;

      // redux, go!

      lazyModule.actions.init(module)(store.dispatch);
      this.modulesRegistered++;
      if (this.modulesRegistered === this.modulesLength) {
        this.registered = true;
        this.forceUpdate();
      }
    });
    this.registered = false;
    this.routes = [];
    this.links = {};
    this.modulesLength = 0;
    this.modulesRegistered = 0;
  }
  componentDidMount() {
    const {
      config
    } = this.props;
    this.register(config.modules);
  }
  render() {
    const {
      config
    } = this.props;
    // console.log(store.getState());

    if (!this.registered) return /*#__PURE__*/_react.default.createElement(_components.Spinner, null);
    return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
      store: store
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex"
    }, /*#__PURE__*/_react.default.createElement(_auth.ShowAuth, null, /*#__PURE__*/_react.default.createElement(_.VerticalMenu, {
      links: this.links
    })), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: "1",
        overflowX: "auto"
      }
    }, /*#__PURE__*/_react.default.createElement(_auth.Authenticator, {
      routes: this.routes,
      components: {},
      generalSettings: config.generalSettings
    })), /*#__PURE__*/_react.default.createElement(_.BaseErrors, null)));
  }
}
var _default = exports.default = ControlPanel;
module.exports = exports.default;